import ApplicantAddressFormHandler from "@Modules/cardManagementSystem/cardholder/containers/formHandler/cardData/customerDetail/applicantAddress/ApplicantAddressFormHandler";
import { useParams } from "react-router-dom";

const ApplicantAddressPage = () => {
  const { id } = useParams();
  const customerId = id || 0;

  return <ApplicantAddressFormHandler customerId={customerId} />;
}

export default ApplicantAddressPage